import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
  zIndexLayers,
} from '../styles';
import { Container } from './ui';

const StyledSaleNotice = styled.section`
  position: sticky;
  bottom: 0;
  z-index: ${zIndexLayers.second};
  padding: 15px 0;
  color: ${standardColours.white};
  background-color: ${standardColours.black};

  ${minBreakpointQuery.large`
    padding-top: 20px;
    padding-bottom: 20px;
  `}
`;

const StyledContent = styled.div`
  p {
    font-weight: ${fontWeights.semibold};
    ${fontSize(14)};
    text-align: center;

    ${minBreakpointQuery.small`
      ${fontSize(15)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(16)};
    `}

    ${minBreakpointQuery.xxlarge`
      ${fontSize(17)};
    `}

    strong {
      color: ${brandColours.nonary};
    }

    a {
      color: ${brandColours.duodenary};
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 2px;
    }
  }
`;

const SaleNotice = () => {
  const {
    datoCmsSale: { notice },
  } = useStaticQuery(graphql`
    query SaleNoticeQuery {
      datoCmsSale {
        notice
      }
    }
  `);

  return (
    notice && (
      <StyledSaleNotice>
        <Container>
          <StyledContent dangerouslySetInnerHTML={{ __html: notice }} />
        </Container>
      </StyledSaleNotice>
    )
  );
};

export default SaleNotice;
